import React, {Component, PropTypes} from 'react'
import Cannonicalize from '../Cannonicalize'
import Carousel from '../Carousel'
import Tile from '../Tile'
import Analytics from '../Analytics';
const LeftControl = (props)=> <span className="fa fa-chevron-left fa-caret-left fa-angle-left" aria-hidden="true"><span className="sr-only">Previous</span></span>
const RightControl = (props) => <span className="fa fa-chevron-right fa-caret-right fa-angle-right" aria-hidden="true"> <span className="sr-only">Next</span></span>


class LayoutCarouselWithFeature extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.state = Cannonicalize.category()
    this.maxSlides = props.maxSlides || 3
    this.startingIndex = props.startingIndex || 0
    this.categoryId = props.categoryId || props.params.id

  }

  componentWillMount() {

    try {
      this.setState(  Cannonicalize.category(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      e.message += ' in LayoutCarouselWithFeature for category #'+ this.categoryId
      Analytics.reportError(e)

    }
    if (typeof window !== 'object')
      return


    ClientSideCacheController.get('category', {id: this.props.categoryId}).then((res) => {
      this.setState(res)
    })
  }

  render() { // REQUIRED
    try {
      if (this.state.features.length < 1)
        return null
    return (
      <div className='gnm-layout-carousel-with-feature' >
        <h3 className='white-at-small'>{this.props.title}</h3>
          <Carousel leftControl ={<LeftControl />} rightControl={<RightControl />} paddingTop='49px'>
            {Array(this.maxSlides).fill(null).map((z,j,zz)=>{
              if(j===0)
                return (
                  <div className='row' key={j}>
                    <div className='col-md-6 feature'>
                      <Tile story={this.state.features[this.startingIndex]}></Tile>
                      <span className='feature-abstract' dangerouslySetInnerHTML={{__html:this.state.features[this.startingIndex].abstract}}></span>
                    </div>
                    <div className='col-md-6'>
                      <div className='row'>
                        {this.state.features.slice(this.startingIndex + 1, this.startingIndex + 5 ).map(function(s,i,a){
                          return (
                              <div className="col-xs-12 col-sm-6 col-md-6" key={i}>
                                <Tile story={s}></Tile>
                              </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                )
              return (
                <div className='row' key={j}>
                  {this.state.features.slice(this.startingIndex + 5 + 8*(j-1),this.startingIndex + 5 + 8*j).map(function(s,i,a){
                    return (
                        <div className="col-xs-12 col-sm-6 col-md-3" key={i}>
                          <Tile story={s}></Tile>
                        </div>
                    )
                  })}
                </div>
              )
            })}
          </Carousel>
          <div className="col-xs-12 hidden-md hidden-lg hidden-xl text-center">
            <a className="btn btn-default" href={'/category/'+this.props.categoryId+ '/top-stories'} role="button">View More Stories</a>
          </div>
      </div>
    )
    }catch(e){
      e.message += ' render failure in LayoutCarouselWithFeature for category #' + this.categoryId
      Analytics.reportError(e)
      return null
    }
  }
}

export default LayoutCarouselWithFeature



// WEBPACK FOOTER //
// ./app/components/custom/ssr/LayoutCarouselWithFeature/index.js